




























































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InstrumentName from "./InstrumentName.vue";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import { DropDownModel, InstrumentSearchRequest, InstrumentStatus } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";


const maxTableRows = 10;

@Component({
  components: {
    PageSizeSelectList, Pagination,
    GenericLoadingSpinner,
    InstrumentName,
  }
})
export default class OpenBrokerageSearch extends Vue {

  @Prop({ required: false }) username: string;

  @Prop({ required: false }) partnerId: number;

  @Prop({ required: false }) accountId: number;

  @Prop({ required: false }) disableBuy: boolean;

  drivewealthStore = useDrivewealthStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  SharedRoutes = SharedRoutes;
  statusMap = drivewealth.statusMap;
  pageSize = 10;
  page = 1;
  searchTerm = null;
  equity = false;
  etf = false;
  mutualFund = false;
  unAvail = false;
  indexFundOnly = false;
  assetClassId = null;
  fundCompanyId = null;
  assetClassName = "Asset Class";
  fundCompanyName = "Fund Company";

  mounted () {
    this.searchTerm = "";
    this.drivewealthStore.loadFundCompanies();
    this.drivewealthStore.loadAssetClasses();
    this.userStore.loadPartnerSettings();
    window.addEventListener("resize", () => this.$forceUpdate());
  }

  beforeDestroy () {
    window.removeEventListener("resize", () => this.$forceUpdate());
  }

  get displayInstrumentPerformanceLink (): boolean {
    return this.featureFlagStore.flags.bend24761DisplayInstrumentPerformanceView;
  }

  @Watch("searchTerm")
  onSearchTermChange (searchValue): void {
    this.searchTerm = searchValue;
    this.page = 1;
    this.debouncedSearch(this.searchRequest);
  }

  onCheckboxChecked () {
    this.page = 1;
    this.debouncedSearch(this.searchRequest);
  }

  onUnAvailChecked () {
    if (this.searchTerm.trim().length > 0) {
      this.page = 1;
      this.debouncedSearch(this.searchRequest);
    }
  }

  debouncedSearch = _.debounce(
      request => this.drivewealthStore.searchInstrumentsWithFundType(request), 600);

  get searchRequest (): InstrumentSearchRequest {
    return {
      searchTerm: this.searchTerm,
      accountId: this.accountId,
      pageNumber: this.page,
      pageSize: this.pageSize,
      availableToBuyOnly: this.disableBuy || !this.unAvail,
      fundTypeBit: this.fundTypeBit,
      assetClassId: this.assetClassId,
      fundCompanyId: this.fundCompanyId,
      indexFundOnly: this.indexFundOnly
    };
  }

  get fundCompanies () {
    return this.drivewealthStore.fundCompanies;
  }

  get getFundCompanyName () {
    return this.fundCompanyName;
  }

  get getAssetClassName () {
    return this.assetClassName;
  }

  onFundCompanySelected (model: DropDownModel) {
    if (!model) {
      this.fundCompanyId = null;
      this.fundCompanyName = "Fund Company";
    } else {
      this.fundCompanyId = model.value;
      this.fundCompanyName = model.text;
    }
    this.page = 1;
    this.debouncedSearch(this.searchRequest);
  }

  get assetClasses () {
    return this.drivewealthStore.assetClasses;
  }

  onAssetClassSelected (model: DropDownModel) {
    if (!model) {
      this.assetClassId = null;
      this.assetClassName = "Asset Class";
    } else {
      this.assetClassId = model.value;
      this.assetClassName = model.text;
    }
    this.page = 1;
    this.debouncedSearch(this.searchRequest);
  }

  get noSearchResults () {
    return !!this.searchTerm && this.drivewealthStore.instrumentSearchIsLoaded &&
        this.drivewealthStore.instrumentSearchResults.length === 0;
  }

  get fundTypeBit () {
    let fundTypeBit = "";

    fundTypeBit += this.mutualFund ? "1" : "0";
    fundTypeBit += this.etf ? "1" : "0";
    fundTypeBit += this.equity ? "1" : "0";

    return fundTypeBit;
  }

  get showBusyState () {
    return this.drivewealthStore.instrumentSearchIsLoading || this.noSearchResults;
  }

  get detailItems () {
    if (!this.drivewealthStore.instrumentSearchResults) {
      return [];
    }

    return this.drivewealthStore.instrumentSearchResults.slice(0, maxTableRows).map(d => ({
      instrument: { symbol: d.stockSymbol, companyName: d.companyName, website: d.website, imageUrl: d.imageUrl },
      status: this.statusMap[d.status],
      action: { symbol: d.stockSymbol },
    }));
  }

  switchPage (toPage): void {
    this.page = toPage;
    this.debouncedSearch(this.searchRequest);
  }

  get detailFields () {
    if (this.disableBuy) {
      return [
        {
          key: "instrument",
          thClass: "text-left pl-2",
          tdClass: "pl-2",
          label: "Investment"
        }
      ];
    }
    return [
      {
        key: "instrument",
        thClass: "text-left pl-2",
        tdClass: "pl-2",
        label: "Investment"
      },
      {
        key: "status",
        label: "Status",
        thClass: "text-center",
        tdClass: "text-center"
      },
      {
        key: "action",
        label: "",
        thClass: "text-center"
      },
    ];
  }

  routeParams (symbol: string): { symbol: string, accountId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId };
    }

    return { symbol };
  }

  get buyRoute (): string {
    return RouteNames.DrivewealthBuyInstrumentV2;
  }

  get isMobileView (): boolean {
    return window.innerWidth <= 768; // Standard mobile breakpoint
  }

  canBuy (instrumentStatus: string) {
    return !this.username && instrumentStatus === this.statusMap[InstrumentStatus.Active] && !this.userStore.partnerDisableInvestmentActivity;
  }
}
